/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-55
 */

"use strict"

import { Df } from "./index__part-53"
import { Pf, Ff } from "./index__part-54"
import * as /* [auto-meaningful-name] */Module_149 from /* 149 */"./149"
import * as /* [auto-meaningful-name] */Src_editor_widget_builtIn_types from /* 5 */"../../../../src/editor/widget/built-in/types"
import * as /* [auto-meaningful-name] */Module_77 from /* 77 */"./77"
var Wf = {
  icon: Module_149.d,
  title: "slider",
  type: Src_editor_widget_builtIn_types.E,
  previewAreaWidgetTitle: "slider",
  component: Pf,
  editConfig: Df,
  blockConfig: Ff,
  isInvisibleWidget: Module_149.f,
  widget: {
    isGlobalWidget: Module_149.e,
    size: {
      width: 280,
      height: 20
    },
    attributes: {
      disabled: false,
      minValue: 0,
      maxValue: 100,
      color: Module_149.b,
      sizeType: Src_editor_widget_builtIn_types.s.MEDIUM,
      direction: Module_77.b.HORIZONTAL,
      sliderType: Module_77.d.TEMPLATE,
      mode: Module_77.c.DEFAULT,
      value: 50,
      step: 1,
      handleImageFileId: Module_149.c,
      handleImageRatio: 2,
      handleImageDirection: Module_77.b.HORIZONTAL,
      backgroundImageFileId: Module_149.a,
      backgroundImageDirection: Module_77.b.HORIZONTAL,
      trackImageFileId: Module_149.g,
      trackImageDirection: Module_77.b.HORIZONTAL
    }
  }
}
export { Wf }
